import { useUpdateUserLanguage } from '@/features/profile/hooks/user'
import useI18n from '@/shared/hooks/usei18n'
import { DeclarantLanguage, LanguageSelector } from '@/common'
import ReactCountryFlag from 'react-country-flag'

const languages = [
  {
    label: 'English',
    value: DeclarantLanguage.enGB,
    flag: <ReactCountryFlag countryCode="GB" svg />
  },
  {
    label: 'Deutsch',
    value: DeclarantLanguage.deDE,
    flag: <ReactCountryFlag countryCode="DE" svg />
  },
  {
    label: 'Español',
    value: DeclarantLanguage.esES,
    flag: <ReactCountryFlag countryCode="ES" svg />
  }
]

export default function DeclarantLanguageSelector({ showLabel = false }: { showLabel?: boolean }) {
  const { handleChangeLanguage, currentLanguage } = useI18n()
  const { mutateAsync: updateLanguage } = useUpdateUserLanguage()

  const currentLanguageOption =
    languages.find(lang => lang.value === currentLanguage) || languages[0]
  const handleChange = (lang: string) => {
    handleChangeLanguage(lang)
    updateLanguage(lang)
  }

  return (
    <LanguageSelector
      languages={languages}
      currentLanguage={currentLanguageOption}
      onChange={handleChange}
      showLabel={showLabel}
    />
  )
}
